module.exports = __webpack_public_path__ + "static/media/import_3.9b98a0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/import_3.jpg
// module id = 1855
// module chunks = 0